import { push } from 'connected-react-router'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { 
    // combineAddress, 
    decideLegalAndOperatingNames, 
    replaceUrlParams 
} from '../../../app/utils'
import { SuccessPanel } from '../../../components/MessagePanels/Panels'
import { Button, ErrorMark } from '../../../components/RegularComponents'
import { agencyApplicationSelector } from '../../../redux/selector/agencyApplicationSelector'
import { mraPrincipalBrokerRenewableStatusSelect, mraPrincipalBrokerSelector } from '../../../redux/selector/mraPrincipalBrokerSelector'
import * as CONST from "../../../app/constants"
import { 
    addAgentApplication, 
    setCurrentAgentApplicationForRenewal, 
    setCurrentAgentApplicationId 
} from '../../../redux/slice/additionalApplicationsSlice'
import { applicationTypeFromLicenceSubType } from '../../../redux/slice/applicationsUtils'
import { saveBusinessLicenceApplicationData } from '../../../redux/slice/businessLicenceApplicationSlice'
import { fetchApplicationWithIdAndSetStore } from '../../../redux/slice/collectionApplicationSlice'
import { setAgencyDataForRenewal } from '../../../redux/slice/primaryAgencyApplicationSlice'
import { fetchArchiveApplicationsForOriginalId } from '../../../redux/slice/archiveApplicationsSlice'
import { fetchRjscFromNumberAndSetDetails } from '../../../redux/slice/rjscSearchSlice'
import { fetchApplicationWithId } from '../../../redux/slice/bltHomeSlice'
import { ERROR_STRING } from '../../../app/errors'

/**
 * Positive use cases : 
 * 1 : agency application renewed, PB not renewed
 * 2 : agney application not renewed, PB renewed
 * 3 : agency application renewed, PB renewed 
 */
export const MraRenewalPaymentConfirmation = () => {

    const paymentRequestDetailsStr = window.sessionStorage.getItem("paymentRequestDetails")
    const paymentDetails = paymentRequestDetailsStr ? JSON.parse(paymentRequestDetailsStr) : null
    const applicationIds = paymentDetails?.map(({applicationId}) => applicationId) ?? []

    // console.log({applicationIds})

    const dispatch = useDispatch()
    
    const applicationType = CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
    const applicationMode = CONST.APPLICATION_MODE_RENEW

    const homePageUrl = replaceUrlParams(
                            CONST.ROUTE_PATH.WELCOME, 
                            applicationType, 
                            applicationMode
                        )

    const { agencyApplication } = useSelector(agencyApplicationSelector);
    const { principalBrokerApplication } = useSelector(mraPrincipalBrokerSelector)
    const { agentApplications } = useSelector(state => state.additionalApplications);
     const { isAgentRenewalEnable } = useSelector(mraPrincipalBrokerRenewableStatusSelect);

    const ONLY_AGENCY_RENEWED = "ONLY_AGENCY_RENEWED"
    const ONLY_PB_RENEWED = "ONLY_PB_RENEWED"
    const AGENCY_PB_RENEWED = "AGENCY_PB_RENEWED"

    const [currentStatus, setCurrentStatus] = useState("")
    const [fetchingApplicationData,setFetchingApplicationData] = useState(false)
    const [applicationSaveError, setApplicationSaveError] = useState(false)

    const [legalName, setLegalName] = useState("")
    const [operatingName, setOperatingName] = useState("")

    useEffect(() => {
        if(!agencyApplication?.businessLicenceData) {
            dispatch(fetchApplicationWithIdAndSetStore(agencyApplication.id))
                .then(data => {
                    const { legalName, operatingName} = decideLegalAndOperatingNames(data?.businessLicenceData?.companyRjscDetails)
                    setLegalName(legalName)
                    setOperatingName(operatingName)
                })
        }
    }, [
        agencyApplication?.businessLicenceData,
        agencyApplication?.id,
        dispatch
    ])

    useEffect(() => {
        
        if(!agencyApplication || !principalBrokerApplication) {
            return
        }

        const { applicationStatus, licencingSubType } = agencyApplication
        const {
            applicationStatus: pbApplicationStatus, 
            licencingSubType: pbLicencingSubType
        } = principalBrokerApplication

        if(licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION
            && pbLicencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION) {
            // case 1
            if(applicationStatus === CONST.APPLICATION_STATUS_UNREAD 
                || applicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW
                || applicationStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY) {
                    setCurrentStatus(ONLY_AGENCY_RENEWED)
            }
        } else if(licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION
            && pbLicencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION) {
            // case 2
            if(pbApplicationStatus === CONST.APPLICATION_STATUS_UNREAD 
                || pbApplicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW) {
                    setCurrentStatus(ONLY_PB_RENEWED)
            }
        } else if(licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION
            && pbLicencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION) {
            // case 3
            if((applicationStatus === CONST.APPLICATION_STATUS_UNREAD 
                || applicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW
                || applicationStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY) 
                && ( pbApplicationStatus === CONST.APPLICATION_STATUS_UNREAD 
                    || pbApplicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW)
                ) {
                    setCurrentStatus(AGENCY_PB_RENEWED) 
                } else if((applicationStatus === CONST.APPLICATION_STATUS_UNREAD 
                    || applicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW
                    || applicationStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY)
                     && (pbApplicationStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT
                            || isAgentRenewalEnable)
                ) {
                    setCurrentStatus(ONLY_AGENCY_RENEWED)
                } else if((pbApplicationStatus === CONST.APPLICATION_STATUS_UNREAD 
                    || pbApplicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW)
                     && applicationStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT
                ) {
                    setCurrentStatus(ONLY_PB_RENEWED)
                }
        }
    }, [agencyApplication, principalBrokerApplication, isAgentRenewalEnable])

    const startPBRenewalFlow = () => {
        if(!agencyApplication || !principalBrokerApplication) {
            return
        }

        const promiseAgencyFetch = dispatch(fetchApplicationWithIdAndSetStore(agencyApplication.id))
        const promisePBFetch = dispatch(fetchApplicationWithId(principalBrokerApplication.id))

        setFetchingApplicationData(true);
        setApplicationSaveError(false);

        Promise.all([promiseAgencyFetch, promisePBFetch]).then(results => {
            const pbApp = results.find(app => app.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION || app.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION)
            if(pbApp) {
                dispatch(addAgentApplication(pbApp));

                dispatch(setCurrentAgentApplicationId(pbApp.id))
                dispatch(setCurrentAgentApplicationForRenewal())

                const appType = applicationTypeFromLicenceSubType(pbApp.licencingSubType)
                dispatch(saveBusinessLicenceApplicationData(appType, CONST.APPLICATION_MODE_RENEW))
                    .then(savedData => {
                        dispatch(
                            push(
                            `${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_RENEWAL_BROKER_CONTACT_INFORMATION}`
                            )
                        )
                    })
                    .catch(() => {
                        setApplicationSaveError(true)
                    })
                    .finally(() => {
                        setFetchingApplicationData(false);
                    })
            }
        })
    }

    const startAgencyRenewalFlow = () => {
        const moveToNext = (agencyApplication) => {
          setFetchingApplicationData(false);
          dispatch(push(`${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_RENEWAL_CONFIRM_PB}`));
        };
    
        setFetchingApplicationData(true);
        setApplicationSaveError(false);

        dispatch(
          fetchApplicationWithIdAndSetStore(agencyApplication.id)
        )
          .then((data) => {
            const proceedToNext = () => {
                dispatch(setAgencyDataForRenewal())
        
                dispatch(saveBusinessLicenceApplicationData(
                    CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, CONST.APPLICATION_MODE_RENEW))
                .then(data => {
        
                    dispatch(fetchArchiveApplicationsForOriginalId(agencyApplication.id))
                    .then(archiveData => {
                    //   console.log("archive data fetched...")
                    })
                    .catch(err => {
                      console.error("error in fetching archive data:  " + err)
                    })
                    .finally(() => {
                      moveToNext(data);
                    })
                })
                .catch(err => {
                  console.error("error in saving application : " + err)
                  setApplicationSaveError(true);
                })
                .finally(() => {
                    setFetchingApplicationData(false);
                })
              }
    
              if (data.businessLicenceData?.companyRjscDetails?.businessEntity?.registryNumber) {
                  dispatch(fetchRjscFromNumberAndSetDetails(data.businessLicenceData.companyRjscDetails.businessEntity.registryNumber))
                  .then(() => {
                    proceedToNext()
                })
              } else {
                proceedToNext()
              }
          })
          .catch((err) => {
            setApplicationSaveError(true);
            setFetchingApplicationData(false);
          })
    }

    const HomePageButton = ({link, title}) => (
        <Button 
            disabled={fetchingApplicationData}
            id="payment-confirmation-go-home-button"
            buttonType={!link ? "regular_primary" : "regular_link"}
            text={title ?? "Go to Mortgage Brokerage Home Page"}
            onClick={() => {dispatch(push(homePageUrl))}}
        />
    )

    const renderButtonComponent = () => {
        if(currentStatus === ONLY_AGENCY_RENEWED) {
            return (
                <div className="row topMarginLarge bottomMarginLarge">
                    <div className={
                            "col-lg-6" +
                            (applicationSaveError ? " has-error" : "")
                        }
                    >
                        <Button
                            showSpinner={fetchingApplicationData}
                            disabled={fetchingApplicationData} 
                            id="payment-confirmation-go-home-button"
                            buttonType="regular_primary"
                            text="Renew the Principal Mortgage Broker's Mortgage Broker Licence"
                            onClick={startPBRenewalFlow}
                        />
                        {(applicationSaveError) && ErrorMark()}
                        {applicationSaveError && (
                        <div className="ns-error-message help-block topMarginNormal">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>
                        )}
                    </div>
                    <div className="col-lg-2">
                        <HomePageButton link />
                    </div>
                </div>
            )
        } else if(currentStatus === ONLY_PB_RENEWED) {
            return (
                <div className="row topMarginLarge bottomMarginLarge">
                    <div className={
                            "col-lg-4" +
                            (applicationSaveError ? " has-error" : "")
                        }
                    >
                        <Button 
                            showSpinner={fetchingApplicationData}
                            disabled={fetchingApplicationData} 
                            id="payment-confirmation-go-home-button"
                            buttonType="regular_primary"
                            text="Renew Mortgage Brokerage Licence"
                            onClick={startAgencyRenewalFlow}
                        />
                        {(applicationSaveError) && ErrorMark()}
                        {applicationSaveError && (
                        <div className="ns-error-message help-block topMarginNormal">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>
                        )}
                    </div>
                    <div className="col-lg-2">
                        <HomePageButton link />
                    </div>
                </div>
            )
        }

        return (
            <div className="row topMarginLarge bottomMarginLarge">
                <div className="col-lg-2">
                    <HomePageButton />
                </div>
            </div>
        )
    }

    const renderStaticText = () => (
        <div className="row topMarginLarge bottomMarginLarge">
            <div className="col-lg-8 bottomMarginNormal">
                Your application will be reviewed by Business Licensing.
            </div>
            <div className="col-lg-8">
                If <b>more information</b> about your application is needed, <b>Business Licensing will contact you.</b>
            </div>
            {(currentStatus === ONLY_PB_RENEWED) && 
            <div className="col-lg-8 topMarginNormal">
                All licensing activities can be completed on the 
                <a 
                    href={`${window.location.protocol}//${window.location.host}/#${homePageUrl}`} 
                    style={{textDecoration : "underline", marginLeft: "5px"}}
                >Mortgage Brokerage Home Page</a>
            </div>}
        </div>
    )

    /*
        1. Your Mortgage Brokerage Licence renewal application was submitted.
        2. The Principal Broker's Mortgage Broker Licence renewal application has been submitted for <pb_name>.
        3. The Mortgage Broker licence renewal application has been submitted for <broker_name>.
        4. Your licence renewal applications have been submitted.
    */
    const renderConfirmationMessageComponent = () => {
        let message = "Your licence renewal application(s) have been submitted."

        if(applicationIds.length === 1) {
            if(agencyApplication?.id === applicationIds[0]) {
                message = "Your Mortgage Brokerage Licence renewal application was submitted."
            } else {
                const agentApplication = agentApplications.find(app => app.id === applicationIds[0])
                
                if(agentApplication?.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION) {
                    message = `The Principal Broker's Mortgage Broker Licence renewal application has been submitted ${agentApplication?.contactName ? `for ${agentApplication?.contactName}` : ''}.`
                } else if(agentApplication?.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION) {
                    message = `The Mortgage Broker licence renewal application has been submitted ${agentApplication?.contactName ? `for ${agentApplication?.contactName}` : ''}.`
                } else if(agentApplication?.licencingSubType === CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION) {
                    message = `The Associate Mortgage Broker licence renewal application has been submitted ${agentApplication?.contactName ? `for ${agentApplication?.contactName}` : ''}.`
                }
            }
        }
    
        return (
            <div className="row topMarginMedium">
                <div className='col-lg-8'>
                    <SuccessPanel>
                        <b>{message}</b>
                    </SuccessPanel>
                </div>
            </div>
        )
    }

    const renderWarningMessage = () => {
        if(currentStatus === ONLY_AGENCY_RENEWED) {
            // case 1
            return (
                <div className="row help-block ns-error-message field-validation-error">
                    <div className="col-lg-8">
                        {ErrorMark()}
                        <span style={{marginLeft: "10px"}}>
                            The <b>Principal Broker's Mortgage Broker Licence</b> must be submitted for renewal and the AIR must be submitted before the Mortgage Brokerage Licence renewal <b>can be approved</b>.
                        </span>
                    </div>
                </div>
            )
        } else if(currentStatus === ONLY_PB_RENEWED) {
            // case 2
            return (
                <div className="row help-block ns-error-message field-validation-error">
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <div>
                            {ErrorMark()}
                        </div>
                        <div>
                            <div className="col-lg-10">
                                The <b>Mortgage Brokerage Licence</b> has not yet been submitted. 
                                The Mortgage Brokerage Licence must be submitted for renewal before 
                                the Principal Broker Licence can be approved.
                            </div>
                        </div>
                    </div>
                    <div className="topMarginLarge" style={{display: "flex", flexDirection: "row"}}>
                        <div>
                            {ErrorMark()}
                        </div>
                        <div>
                            <div className="col-lg-12">
                                The <b>Brokerage Licence</b> can now be renewed.
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return null;
    }

    const renderHeader = () => {
        const label1 = (operatingName ? operatingName : (legalName ?? "Payment Confirmation"))
        const label2 = operatingName ? legalName : null

        return (
        <div className="row topMarginMedium">
            <div className="col-lg-8" style={{fontSize: "2.2rem"}}>
                {label1}
            </div>
            {label2 && 
            <div className="col-lg-8" style={{fontSize: "1.6rem"}}>
                {label2}
            </div>}
        </div>)
    }

    return (
        <div className="container">
            { renderHeader() }
            { renderConfirmationMessageComponent() }
            { renderStaticText() }
            { renderWarningMessage() }
            {renderButtonComponent()}
        </div>
    )
}
